import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { EmptyCard3 } from "@shadcn/pro-blocks/application/empty-sections/empty-section-4";
import { createFileRoute } from "@tanstack/react-router";
import { Boxes, Container, Lock, Navigation, ReceiptText } from "lucide-react";
import { AppHeader } from "~/components/layout/AppHeader";
import { PageContainer } from "~/components/layout/PageContainer";

export const Route = createFileRoute("/support/how-to-use/one-delivery")({
	beforeLoad: () => {
		document.title = 'bacehub | Chat & Support'
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	const i18n = useI18nContext().LL["new-ui"];

	return (
		<PageContainer>
			<AppHeader service="ALL" />
			<h1 className="text-2xl font-breit px-6 py-4">
				<T>{i18n.ONE_DELIVERY_HOW_IT_WORKS()}</T>
			</h1>
			<div className="mx-6">
				<EmptyCard3 icon={Container} title={i18n.SELECT_YOUR_PLAN()} description={i18n.SELECT_YOUR_PLAN_DESC()} />
				<EmptyCard3 icon={ReceiptText} title={i18n.COMPLETE_ORDER()} description={i18n.COMPLETE_ORDER_DESC()} />
				<EmptyCard3 icon={Navigation} title={i18n.USE_YOUR_ADDRESS()} description={i18n.USE_YOUR_ADDRESS_DESC()} />
				<EmptyCard3 icon={Lock} title={i18n.NOTIFICATION_WILL_BE_SENT()} description={i18n.NOTIFICATION_WILL_BE_SENT_DESC()} />
				<EmptyCard3 icon={Boxes} title={i18n.MANAGE_YOUR_SHIPMENTS()} description={i18n.MANAGE_YOUR_SHIPMENTS_DESC()} />
			</div>
		</PageContainer>
	);
}
